import { TachoWorkState } from "@src/app/interfaces/tachograph.interface";

export const DEFAULT_COLORS: Record<TachoWorkState, string> = {
  [TachoWorkState.Rest]: '#2D78FF',
  [TachoWorkState.Ready]: '#F5BE23',
  [TachoWorkState.Work]: '#FF0032',
  [TachoWorkState.Drive]: '#32C80F',
  [TachoWorkState.None]: '#F8F8F8',
};
